// extracted by mini-css-extract-plugin
module.exports = {"button":"PaymentForm_button__nO7Qn","form":"PaymentForm_form__sQJY3","error":"PaymentForm_error__0tc4_","grid":"PaymentForm_grid__42UVy"};